import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

// project imports
import useAuth from 'hooks/useAuth';
import { autoLogOut } from '../../services/checkTokenExpiry';
import { DecryptJweToken } from '../../services/EncDecService';
import { jwtDecode } from 'jwt-decode';
import { sessionDataDec } from '../../services/sessionServiceEndDec';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const verifyToken = async () => {
      const token = sessionDataDec('token')
      if (!token) {
        navigate('/login', {
          state: {
            from: ''
          },
          replace: true
        });
        window.history.pushState(null, "", window.location.href);
        return;
      }
      let jweToken = await DecryptJweToken(token)
      const decoded = jwtDecode(jweToken);
      const exp = decoded.exp * 1000;

      const now = new Date().getTime();
      if (exp <= now) {
        await autoLogOut();
      }

      if (!isLoggedIn) {
        navigate('/login', {
          state: {
            from: ''
          },
          replace: true
        });
      }
    };

    verifyToken();

  }, [isLoggedIn, navigate]);

  if (!isLoggedIn || !sessionDataDec('token')) {
    return null; // Prevents rendering protected components after logout or invalid session, stopping crashes
  }

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
